import { PATHNAMES } from "src/constants/routes";
import { infoLinks, mainLinks } from "./trns";

export const FOOTER_LINKS = {
  MAIN_LINKS: [
    {
      id: 1,
      label: {
        i18nKey: mainLinks.home,
      },
      href: PATHNAMES.HOME,
    },
    {
      id: 2,
      label: {
        i18nKey: mainLinks.opportunities,
      },
      href: PATHNAMES.OPPORTUNITIES,
    },
    {
      id: 3,
      label: {
        i18nKey: mainLinks.aboutUs,
      },
      href: PATHNAMES.ABOUT_US,
    },
    {
      id: 4,
      label: {
        i18nKey: mainLinks.contactUs,
      },
      href: PATHNAMES.CONTACT_US,
    },
    {
      id: 5,
      label: {
        i18nKey: mainLinks.blog,
      },
      href: PATHNAMES.BLOG,
    },
  ],
  INFO_LINKS: [
    {
      id: 1,
      label: {
        i18nKey: infoLinks.termsDisclaimer,
      },
      href: PATHNAMES.TERMS_OF_USE,
    },
    {
      id: 2,
      label: {
        i18nKey: infoLinks.privacyPolicy,
      },
      href: PATHNAMES.PRIVE_POLICY,
    },
    {
      id: 3,
      label: {
        i18nKey: infoLinks.cookiePolicy,
      },
      href: PATHNAMES.COOKIE_POCILY,
    },
  ],
};
